import { render } from "./UserTests.vue?vue&type=template&id=298ace9c&scoped=true"
import script from "./UserTests.vue?vue&type=script&lang=js"
export * from "./UserTests.vue?vue&type=script&lang=js"

import "./UserTests.vue?vue&type=style&index=0&id=298ace9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298ace9c"]])

export default __exports__